import { render, staticRenderFns } from "./ProgrammMeta.vue?vue&type=template&id=4b062f04&scoped=true&"
import script from "./ProgrammMeta.vue?vue&type=script&lang=js&"
export * from "./ProgrammMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b062f04",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/ProgrammMeta.vue
// module id = null
// module chunks = 